import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderLink2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"folder-link-2, link, attachment"} maskId="square-filled-radius-0-stroke-1-IconFolderLink2"><path d="M2 3H10.2676L12.2676 6H22V20H14V11H2V3Z" fill="currentColor"/><path fillRule="evenodd" clipRule="evenodd" d="M4.75 16.5H8.25V17.5H4.75V16.5Z" fill="currentColor"/><path d="M1 13V21H5.25V20H2V14H5.25V13H1Z" fill="currentColor"/><path d="M12 13V21H7.75V20H11V14H7.75V13H12Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconFolderLink2;
